export const REQUIRED_MENU_TITLE_FIELDS = [
  'id',
  'parentId',
  'title',
  'description',
  'diets',
  'addons',
  'miscInfo',
  'allergens',
  'nutritions',
  'calories',
]

export const REQUIRED_DISH_FIELDS = [
  'id',
  'menuTitleId',
  'name',
  'description',
  'ingredients',
  'price',
  'diets',
  'addons',
  'miscInfo',
  'allergens',
  'nutritions',
  'calories',
]
